import { Injectable } from '@angular/core';
import { ToastController, LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  loader;

  constructor(
    private toastController: ToastController,
    private loadingController: LoadingController,
  ) {

  }

  async showToast(msg, clr = 'light') {
    const toast = await this.toastController.create({
      message: msg,
      duration: 4000,
      position: 'bottom',
      color: clr
    });
    toast.present();
  }

  async showLoader(content = 'Loading ...',duration=0) {
    console.log('showLoader', content, duration);
    let obj = { message: content};
    if(duration){
      obj = Object.assign(obj,{duration: duration});
    }
    this.loader = await this.loadingController.create(obj);
    this.loader.present();
  }

  async dismissLoader() {
    console.log('dismissLoader');
    if (this.loader) {
      await this.loader.dismiss();
    }
  }
  
}
